module.exports = __webpack_public_path__ + "img/snb_bsgs.cc5bcd8d.svg";